
import { useState, useCallback, useEffect, useRef } from 'react';
import { fetchDataFailure, fetchDataStart, fetchDataSuccess } from '..//store/slice/search_applist_slice';
import { getNaaBarAppListing, logOut, tokenverfy } from '..//services/seller/api';
import { useDispatch, useSelector } from 'react-redux';
import { Route, useLocation, useNavigate } from 'react-router-dom';
import { EmailIcon, ExitIcon, ProfileIcon } from '@shopify/polaris-icons';
import { FaBars, FaTimes } from 'react-icons/fa';
import './AppStore.scss';
import './fotter.scss'
import CloseIcon from '@mui/icons-material/Close';
import { bread, searchIcon, emailIcon, logoutIcon } from '../../assets';
import enTranslations from "@shopify/polaris/locales/en.json";
import SearchIcon from '@mui/icons-material/Search';
import { loggedIn, loggedOut } from '..//store/slice/authSlice';
import { ToastContainer, toast } from 'react-toastify';
import AppData from '../components/interface/nav_bar_Interface/nav_bar_interface';
import React from 'react'
import TextField from '@mui/material/TextField';
import Autocomplete, { createFilterOptions } from '@mui/material/Autocomplete';
import IconButton from '@mui/material/IconButton';
import { Box, InputAdornment, styled } from '@mui/material'
import { useMediaQuery } from 'react-responsive';
import AccountCircleIcon from '@mui/icons-material/AccountCircle';
import ReactGA from "react-ga4";
import { captureGAEvent, gaPanelConfig } from '../shared/helper';
import { Avatar, TopBar } from '@shopify/polaris';
import { clearEvents, } from '../utils/changeHeaderColor';


export default function AppStoreHeader() {
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const navBarData: AppData[] | null = useSelector((state: { searchAppList: { data: AppData[] | null } }) => state.searchAppList.data);
  const dispatch = useDispatch();

  let code: any = window.location.href.split("token=")[1];
  const slugDatas: string = window.location.href.split("/")[3];

  const authUrl = process.env.REACT_APP_REDIRECT_URL;

  const nextRedirectUrl = process.env.REACT_APP_WEB_BASE_URL;

  const gaTrakingID = process.env.REACT_APP_GA_ID;
  const auth = useSelector((state: any) => state.auth);
  const firstName = localStorage.getItem("first_name") ?? "";
  const email = localStorage.getItem("email") ?? "";

  const [isUserMenuOpen, setIsUserMenuOpen] = useState(false);
  const [isUserMenuOpenM, setIsUserMenuOpenM] = useState(false);

  const [searchValue, setSearchValue] = useState('');
  const [searchGaValue, setSearchGaValue] = useState('');
  const [showCloseIcon, setShowCloseIcon] = useState(false);



  const navRef = useRef<HTMLDivElement>(null);


  const showNavbar = () => {
    if (navRef.current) {
      setIsImageVisible(!isImageVisible);
      navRef.current.classList.toggle("responsive_nav");

    }
  };
  const handleInputChange = (event, inputValue) => {
    setSearchValue(inputValue);
    setShowCloseIcon(inputValue !== '');
    gaPanelConfig.search_term = inputValue;

    // Send GA event for input change
    sendGAEvent("sras_search");
  };
  const removeTokenFromURL = () => {
    const url = new URL(window.location.href);
    url.searchParams.delete('token');
    window.history.replaceState({}, '', url.toString());
  };
  const [isImageVisible, setIsImageVisible] = useState(true);
  ///new nav bar
  const handleClick = () => setClick(!click);
  const [click, setClick] = useState(false);
  const [color, setColor] = useState(true);
  const [otherRoute, setOtherRoute] = useState(false);
  const location = useLocation();
  const isTabletOrMobile = useMediaQuery({ query: '(max-width: 1000px)' });



  if (isTabletOrMobile) {
    gaPanelConfig.device = "Mobile";
    // Tablet view
    console.log('Tablet view detected');
  } else {
    gaPanelConfig.device = "Web";
    // Web view
    console.log('Web view detected');
  }
  // Function to toggle the visibility of the image
  const toggleImageVisibility = () => {
    showNavbar();
    setIsImageVisible(!isImageVisible);

  };
  const refresh = () => {
    window.location.reload()
  };
  const handleClickIcons = (newUrl) => {
    window.history.pushState({ path: newUrl }, '', newUrl);
    // Force a re-render of components
    window.dispatchEvent(new Event('popstate'));
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };
  useEffect(() => {

    if (gaTrakingID) {
      // Initialize Google Analytics with the tracking ID
      ReactGA.initialize(gaTrakingID);


    } else {
      console.error('REACT_APP_GA_ID environment variable is not defined.');
    }

    localStorage.removeItem('prevLoadedApps');
    setLoading(true);

    fetchData()
      .then(async (response) => {
        console.log('Response:', response);
        // Attempt to get the 'satellizer_token' from the cookies
        // const code = getCookie('satellizer_token') ?? "";
        // console.log("satellizer_token => " + code);

        if (code !== undefined) {

          const data = {
            token: code,
            validate_token_request: 1,
          };

          setTimeout(() => {
            // setLoading(true);
            tokenverfy(data)
              .then((response) => {
                console.log("Token verification response:", response);
                dispatch(
                  loggedIn({
                    userData: {
                      first_name: response.data.userData.first_name,
                      last_name: response.data.userData.last_name,
                      company_name: response.data.userData.company_name,
                      email: response.data.userData.email,
                    },
                    model: {
                      company_id: response.data.model.company_id,
                    },
                    result: response.data.result, // This already contains the array of accounts
                    token: code,  // Use the stored token
                  })
                );
              
                
                const slugData = localStorage.getItem('slug');
                console.log("slugname=> " + slugData);

                if (slugData != null) {
                  removeTokenFromURL()
                  const slug = slugData;
                  localStorage.removeItem('slug');
                  // window.location.href = `/${slug}`;
                  ///remove below line when fix above code
                  // window.location.href = `/`;

                } else {
                  removeTokenFromURL()
                  // window.location.href = `/`;
                  setLoading(false);
                }
              })
              .catch((error) => {

                localStorage.clear();
                code = null;
                dispatch(loggedOut());
                setLoading(false);
                console.error("Error during token verification:", error.message);
                window.location.href = `/`;
              })

          }, 800);

        }
        setLoading(false);
      })
      .catch((error) => {
        console.error('Error fetching data:', error);
      });
  }, [auth.token]);


  useEffect(() => {
    const interval = setInterval(async () => {
      const storetoken = localStorage.getItem("satellizer_token");
      if (storetoken !== null) {
        const data = {
          token: storetoken,
          validate_token_request: 1,
        };

        try {
          const response = await tokenverfy(data);
          // console.log("Token verification response:", response);
          dispatch(
            loggedIn({
              userData: {
                first_name: response.data.userData.first_name,
                last_name: response.data.userData.last_name,
                company_name: response.data.userData.company_name,
                email: response.data.userData.email,
              },
              model: {
                company_id: response.data.model.company_id,
              },
              result: response.data.result, // This already contains the array of accounts
              token: storetoken,  // Use the stored token
            })
          );
        } catch (error: any) {
          localStorage.clear();
          code = null;
          dispatch(loggedOut());
          console.error("Error during token verification:", error.message);
        }
      }
    }, 40000); // 10 seconds in milliseconds

    // Clean up the interval on unmount or when the component re-renders
    return () => clearInterval(interval);
  }, []); // Add dependencies to re-run the effect when they change


  const fetchData = async () => {
    try {
      dispatch(fetchDataStart());
      const response = await getNaaBarAppListing();
      const responseData = response.data || [];
      // console.log(responseData)
      dispatch(fetchDataSuccess(responseData));
      // console.log('Response:', responseData);

    } catch (error) {
      dispatch(fetchDataFailure(error));
      // console.error('Error fetching data:', error);
    }
  };
  const handleLogin = async () => {
    clearEvents();
    sendGAEvent("sras_login_button")
    try {
      // Set loading state to true
      setLoading(true); // Start loading

      // Redirect to the login URL
      if (slugDatas) {
        // Remove trailing slash from nextRedirectUrl and leading slash from slugDatas
        const formattedNextRedirectUrl = nextRedirectUrl?.replace(/\/$/, '') || '';
        const formattedSlugDatas = slugDatas?.replace(/^\//, '') || '';
    
        // Combine the formatted URLs
        const combinedUrl = `${formattedNextRedirectUrl}/${formattedSlugDatas}`;
    
        // No need to encode the combined URL
        removeTokenFromURL();
        window.location.href = `${authUrl}/login?nextRedirectUrl=${combinedUrl}`;
    } else {
        window.location.href = `${authUrl}/login?nextRedirectUrl=${nextRedirectUrl}`;
    }
    
    



    } catch (error) {
      console.error('Error occurred during login:', error);
    }
  };
  ///Logout mehtods
  const handleLogout = () => {
    console.log('User logged out!');
    localStorage.clear();
    localStorage.removeItem("satellizer_token");
    code = null;
    dispatch(loggedOut());
    const authUrl = process.env.REACT_APP_REDIRECT_URL;
    const nextRedirectUrl = process.env.REACT_APP_WEB_BASE_URL;
    console.log('Cookies cleared successfully');
    window.location.href = '/';




    // Redirect to the logout URL with nextRedirectUrl parameter
    // clearCookies();

  };
  const clearCookies = async () => {
    try {
      const data = { "is_new_version": "true" };
      await logOut(data, auth.token)
        .then((res: any) => {
          toast.success(res?.message);
        })
        .catch((err: any) => {
          toast.error(err?.message);
        });

      // Get the current date and time
      const currentDate = new Date();

      // Convert the current date and time to a UTC string format
      const expirationDate = currentDate.toUTCString();

      // Extract the base domain from the current URL
      const currentUrl = window.location.href;
      const urlParts = currentUrl.split('/');
      const baseDomain = urlParts[2].split('.').slice(-2).join('.');
      console.log("Base Domain => ", baseDomain);

      // Get all cookies stored in the browser
      const cookies = document.cookie.split(';');

      // Iterate through each cookie
      cookies.forEach(cookie => {
        const cookieParts = cookie.split('=');
        const cookieName = cookieParts[0].trim();
        const domain = `.${baseDomain}`; // Set the domain to delete cookies from

        // Check if the cookie belongs to the target domain
        if (cookieName && cookieName !== '' && cookieName.includes(domain)) {
          // Delete the cookie by setting its expiration date to the current time
          document.cookie = `${cookieName}=; expires=${expirationDate}; domain=${domain}; path=/;`;
        }
      });

      // Clear localStorage
      localStorage.clear();

      console.log('Cookies cleared successfully');
      window.location.href = '/';
    } catch (error) {
      console.error('Error clearing cookies:', error);
    }
  };

  const logoTest = {
    TopBarSource: AccountCircleIcon,
    accessibilityLabel: 'Shopify'
  }

  const toggleIsUserMenuOpen = useCallback(() => setIsUserMenuOpen((isUserMenuOpen) => !isUserMenuOpen), []);


  const userMenuMarkup = (
    <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
      <div className="block md:hidden" style={{ marginRight: 'auto' }}>
        <div style={{ display: 'flex', justifyContent: 'flex-end' }} className='container'>
          <header>
            <nav ref={navRef}>
              <div className='search-boxM'>
                <div   >
                  <Autocomplete
                    freeSolo
                    id="free-solo-2-demo"
                    disableClearable
                    value={searchValue}
                    onInputChange={handleInputChange}

                    onChange={(event, newValue: string | AppData) => {


                      const newSearchValue = typeof newValue === 'string' ? newValue : newValue.name;


                      setSearchValue(newSearchValue || '');
                      if (newSearchValue) {

                        const selectedApp = navBarData!.find((app: AppData) => app.name === newSearchValue);
                        if (selectedApp) {
                          clearEvents();

                          // Your logic for setting GA event and navigating
                          console.log(`Selected item: ${selectedApp.name}`);

                          gaPanelConfig.select_item = selectedApp.name;
                          gaPanelConfig.select_result = "YES";

                          sendGAEvent("sras_search")
                          const newUrl = `/${selectedApp.slug}`;
                          window.history.pushState({ path: newUrl }, '', newUrl);
                          window.dispatchEvent(new Event('popstate'));
                          window.scrollTo({ top: 0, behavior: 'smooth' });
                        } else {
                          gaPanelConfig.search_term = newSearchValue;
                          gaPanelConfig.select_item = "NO";
                          sendGAEvent("sras_search")
                          setSearchValue('');
                        }
                      }
                    }}

                    filterOptions={(options, params) => {
                      console.log(params.inputValue)


                      if (params.inputValue === '') {

                        return [];
                      } else {

                        const filteredApps = (navBarData || []).filter((app: AppData) =>
                          app.name.toLowerCase().includes(params.inputValue.toLowerCase())
                        );
                        if (filteredApps.length === 0) {

                          return ['No data found'];
                        }
                        return filteredApps; // Return the filtered array directly
                      }
                    }}
                    selectOnFocus
                    clearOnBlur
                    handleHomeEndKeys
                    options={(navBarData || [])}
                    getOptionLabel={(option: string | AppData) => {
                      if (typeof option === 'string') {
                        return option; // Return the string directly
                      } else {
                        return option.name; // Return the name property of the AppData object
                      }
                    }}

                    renderOption={(props, option: string | AppData, state, ownerState) => (
                      <li {...props}>
                        {typeof option === 'string' ? (
                          <span>{option}</span>
                        ) : (
                          <Box sx={{ display: 'flex', alignItems: 'center' }}>
                            <img
                              loading="lazy"
                              width="25"
                              src={option.app_icon}
                              alt=""
                              style={{ marginRight: 15 }} // Adjust spacing as needed
                            />
                            <span>{option.name}</span>
                          </Box>
                        )}
                      </li>
                    )}

                    renderInput={(params) => (
                      <TextField
                        {...params}
                        variant="outlined"
                        placeholder="Search apps & more..."
                        InputProps={{
                          ...params.InputProps,
                          type: 'search',
                          startAdornment: (
                            <InputAdornment position="start">
                              <SearchIcon sx={{ color: 'white', marginRight: 1 }} fontSize="small" />
                            </InputAdornment>
                          ),
                          endAdornment: showCloseIcon && (
                            <IconButton
                              sx={{
                                color: '#ccc',
                              }}
                              edge="end"
                              onClick={() => {
                                setSearchValue('');
                                setShowCloseIcon(false);
                              }}
                            >
                              {/* <CloseIcon /> */}
                            </IconButton>
                          ),
                          sx: {
                            marginTop: "10px",
                            height: "60px",
                            borderRadius: "10px",
                            borderWidth: ".2vh",
                            borderColor: "#6945E2",
                            color: 'white',
                            backgroundColor: '',
                            '&::placeholder': { textAlign: 'center' }
                          }
                        }}
                      />
                    )}
                  />
                </div>
                <div>
                </div>
              </div>
              <button className="nav-btn nav-close-btn" onClick={showNavbar}>
                <FaTimes />

              </button>
            </nav>
            {isImageVisible && (
              <button className="nav-btn" onClick={toggleImageVisibility}>
                <img
                  style={{ bottom: "6px", maxWidth: '100%', maxHeight: '100%', padding: "10px", background: "transparent" }}
                  width={50}
                  height={50}
                  alt=""
                  srcSet={searchIcon}
                  src={searchIcon}
                />
              </button>
            )}
          </header>
        </div>
        <div className='searchColorClose lg:w-1/2 xl:w-1/3'>
          <div> </div>
        </div>
      </div>
      <div className='logo-user'>
        <div style={{ width: "80px" }}></div>
        <TopBar.UserMenu
          actions={[
            {
              items: [{ content: firstName, icon: ProfileIcon }],
            },
            {
              items: [
                {
                  content: 'Logout',
                  icon: ExitIcon,
                  onAction: handleLogout,
                },
              ],
            },
          ]}
          name={''}
          initials={''}
          open={isUserMenuOpen}
          onToggle={toggleIsUserMenuOpen}
          avatar='https://iili.io/JETT4gs.png'
        />

      </div>
    </div>

  );

  ///appheader condition change background
  useEffect(() => {
    console.log("----------", window.location.pathname)
    if (window.location.pathname === '/') {
      setColor(false);
      setOtherRoute(false);
    } else {
      setColor(true);
      setOtherRoute(true);
    }
  }, [location]);

  const changeColor = () => {
    if (window.location.pathname === '/') {
      if (window.scrollY >= 30) {
        setColor(true);
      } else {
        setColor(false);
      }
    } else {
      if (window.scrollY >= 0) {
        setColor(true);
      } else {
        setColor(false);
      }
    }
  };

  // Add event listener to handle scroll color change
  window.addEventListener('scroll', changeColor);
  const closeMenu = () => setClick(false);
  const [isOpen, setIsOpen] = useState(false);
  const popoverRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (popoverRef.current && !popoverRef.current.contains(event.target as Node)) {
        setIsOpen(false);
      }
    };

    if (isOpen) {
      document.addEventListener('click', handleClickOutside);
    } else {
      document.removeEventListener('click', handleClickOutside);
    }

    return () => {
      document.removeEventListener('click', handleClickOutside);
    };
  }, [isOpen]);

  const togglePopover = () => {
    setIsOpen(!isOpen);
  };
  const sendGAEvent = (event: string) => {
    captureGAEvent(event, event);
  };
  const handleClicks = (e: React.MouseEvent<HTMLAnchorElement>) => {
    clearEvents();

    e.preventDefault(); // Prevent default anchor behavior
    handleClickIcons('/');

    sendGAEvent("sras_home_logo")
  };


  return (
    <>
      <div className='container'>
        <div className={`header ${color ? 'header-bg' : ''}`} >
          <div className='container'>
            <div className='navbar-custom'>
              <a className='app-logo' href="/" onClick={handleClicks}>
                <img src={'https://s3-ap-southeast-1.amazonaws.com/kr-multichannel/appstore/app_1718863505_appstore-logo.png'} alt='logo' />
              </a>

              <div style={{ paddingRight: firstName === '' ? undefined : "90px" }} className={click ? 'nav-menu active' : 'nav-menu'}>

                <div className="hidden md:block">
                  <div className='searchColorClose lg:w-1/2 xl:w-1/3'>
                    <div className='search-box'  >
                      <Autocomplete
                        freeSolo
                        id="free-solo-2-demo"
                        disableClearable
                        value={searchValue}
                        onInputChange={handleInputChange}
                        onChange={(event, newValue: string | AppData) => {

                          console.log(newValue);

                          const newSearchValue = typeof newValue === 'string' ? newValue : newValue.name;
                          console.log("my value" + newValue)

                          setSearchValue(newSearchValue || '');
                          if (newSearchValue) {

                            const selectedApp = navBarData!.find((app: AppData) => app.name === newSearchValue);
                            if (selectedApp) {

                              clearEvents();

                              // Your logic for setting GA event and navigating
                              console.log(`Selected item: ${selectedApp.name}`);

                              gaPanelConfig.select_item = selectedApp.name;
                              gaPanelConfig.select_result = "YES";

                              sendGAEvent("sras_search")
                              const newUrl = `/${selectedApp.slug}`;
                              window.history.pushState({ path: newUrl }, '', newUrl);
                              window.dispatchEvent(new Event('popstate'));
                              window.scrollTo({ top: 0, behavior: 'smooth' });
                            } else {
                              gaPanelConfig.search_term = newSearchValue;
                              gaPanelConfig.select_item = "NO";
                              sendGAEvent("sras_search")
                              setSearchValue('');
                            }
                          }
                        }}

                        filterOptions={(options, params) => {
                          console.log(params.inputValue)


                          if (params.inputValue === '') {
                            return [];
                          } else {
                            const filteredApps = (navBarData || []).filter((app: AppData) =>
                              app.name.toLowerCase().includes(params.inputValue.toLowerCase())
                            );
                            if (filteredApps.length === 0) {
                              gaPanelConfig.select_item = "NA";
                              sendGAEvent("sras_search")
                              return ['No data found'];
                            }
                            return filteredApps; // Return the filtered array directly
                          }
                        }}
                        selectOnFocus
                        clearOnBlur
                        handleHomeEndKeys
                        options={(navBarData || [])}
                        getOptionLabel={(option: string | AppData) => {
                          if (typeof option === 'string') {
                            return option; // Return the string directly
                          } else {
                            return option.name; // Return the name property of the AppData object
                          }
                        }}

                        renderOption={(props, option: string | AppData, state, ownerState) => (
                          <li {...props}>
                            {typeof option === 'string' ? (
                              <span>{option}</span>
                            ) : (
                              <Box sx={{ display: 'flex', alignItems: 'center' }}>
                                <img
                                  loading="lazy"
                                  width="25"
                                  src={option.app_icon}
                                  alt=""
                                  style={{ marginRight: 15 }} // Adjust spacing as needed
                                />
                                <span>{option.name}</span>
                              </Box>
                            )}
                          </li>
                        )}

                        renderInput={(params) => (
                          <TextField
                            {...params}
                            variant="outlined"
                            placeholder="Search apps & more..."
                            InputProps={{
                              ...params.InputProps,
                              type: 'search',
                              startAdornment: (
                                <InputAdornment position="start">
                                  <SearchIcon sx={{ color: 'white', marginRight: 1 }} fontSize="small" />
                                </InputAdornment>
                              ),
                              endAdornment: showCloseIcon && (
                                <IconButton
                                  sx={{
                                    color: '#ccc',
                                  }}
                                  edge="end"
                                  onClick={() => {
                                    setSearchValue('');
                                    setShowCloseIcon(false);
                                  }}
                                >
                                  {/* <CloseIcon /> */}
                                </IconButton>
                              ),
                              sx: {
                                marginTop: "10px",
                                height: "60px",
                                borderRadius: "10px",
                                borderWidth: ".2vh",
                                borderColor: "#6945E2",
                                color: 'white',
                                backgroundColor: '',
                                '&::placeholder': { textAlign: 'center' }
                              }
                            }}
                          />
                        )}
                      />

                    </div>
                    <div>
                    </div>
                  </div>
                </div>

                {/* Second div - Show on mobile view */}

              </div>
              {firstName === "" ? (
                <div>
                  <div style={{ height: "fit-content", }} className="user-menu flex flex-col md:flex-row">

                    <div style={{ width: "50px" }}></div>

                    {/* ///mobile                */}
                    <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
                      <div className="block md:hidden" style={{ marginRight: 'auto' }}>
                        <div style={{ display: 'flex', justifyContent: 'flex-end' }} className='container'>
                          <header>
                            <nav ref={navRef}>
                              <div className='search-boxM'>
                                <div   >
                                  <Autocomplete
                                    freeSolo
                                    id="free-solo-2-demo"
                                    disableClearable
                                    value={searchValue}
                                    onInputChange={handleInputChange}
                                    onChange={(event, newValue: string | AppData) => {

                                      const newSearchValue = typeof newValue === 'string' ? newValue : newValue.name;
                                      console.log("my value" + newValue)

                                      setSearchValue(newSearchValue || '');
                                      if (newSearchValue) {

                                        const selectedApp = navBarData!.find((app: AppData) => app.name === newSearchValue);
                                        if (selectedApp) {
                                          clearEvents();

                                          // Your logic for setting GA event and navigating
                                          console.log(`Selected item: ${selectedApp.name}`);

                                          gaPanelConfig.select_item = selectedApp.name;
                                          gaPanelConfig.select_result = "YES";

                                          sendGAEvent("sras_search")
                                          const newUrl = `/${selectedApp.slug}`;
                                          window.history.pushState({ path: newUrl }, '', newUrl);
                                          window.dispatchEvent(new Event('popstate'));
                                          window.scrollTo({ top: 0, behavior: 'smooth' });
                                        } else {
                                          gaPanelConfig.search_term = newSearchValue;
                                          gaPanelConfig.select_item = "NO";
                                          sendGAEvent("sras_search")
                                          setSearchValue('');
                                        }
                                      }
                                    }}

                                    filterOptions={(options, params) => {
                                      // console.log("my value" + params.inputValue)

                                      if (params.inputValue === '') {
                                        return [];
                                      } else {
                                        const filteredApps = (navBarData || []).filter((app: AppData) =>
                                          app.name.toLowerCase().includes(params.inputValue.toLowerCase())
                                        );
                                        if (filteredApps.length === 0) {
                                          return ['No data found'];
                                        }
                                        return filteredApps; // Return the filtered array directly
                                      }
                                    }}
                                    selectOnFocus
                                    clearOnBlur
                                    handleHomeEndKeys
                                    options={(navBarData || [])}
                                    getOptionLabel={(option: string | AppData) => {
                                      if (typeof option === 'string') {
                                        return option; // Return the string directly
                                      } else {
                                        return option.name; // Return the name property of the AppData object
                                      }
                                    }}

                                    renderOption={(props, option: string | AppData, state, ownerState) => (
                                      <li {...props}>
                                        {typeof option === 'string' ? (
                                          <span>{option}</span>
                                        ) : (
                                          <Box sx={{ display: 'flex', alignItems: 'center' }}>
                                            <img
                                              loading="lazy"
                                              width="25"
                                              src={option.app_icon}
                                              alt=""
                                              style={{ marginRight: 15 }} // Adjust spacing as needed
                                            />
                                            <span>{option.name}</span>
                                          </Box>
                                        )}
                                      </li>
                                    )}

                                    renderInput={(params) => (
                                      <TextField
                                        {...params}
                                        variant="outlined"
                                        placeholder="Search apps & more..."
                                        InputProps={{
                                          ...params.InputProps,
                                          type: 'search',
                                          startAdornment: (
                                            <InputAdornment position="start">
                                              <SearchIcon sx={{ color: 'white', marginRight: 1 }} fontSize="small" />
                                            </InputAdornment>
                                          ),
                                          endAdornment: showCloseIcon && (
                                            <IconButton
                                              sx={{
                                                color: '#ccc',
                                              }}
                                              edge="end"
                                              onClick={() => {
                                                setSearchValue('');
                                                setShowCloseIcon(false);
                                              }}
                                            >
                                              {/* <CloseIcon /> */}
                                            </IconButton>
                                          ),
                                          sx: {
                                            marginTop: "10px",
                                            height: "60px",
                                            borderRadius: "10px",
                                            borderWidth: ".2vh",
                                            borderColor: "#6945E2",
                                            color: 'white',
                                            backgroundColor: '',
                                            '&::placeholder': { textAlign: 'center' }
                                          }
                                        }}
                                      />
                                    )}
                                  />
                                </div>
                                <div>
                                </div>
                              </div>

                              <button className="nav-btn nav-close-btn" onClick={showNavbar}>
                                <FaTimes />

                              </button>
                            </nav>
                            {isImageVisible && (
                              <button className="nav-btn" onClick={toggleImageVisibility}>
                                <img
                                  style={{ bottom: "6px", maxWidth: '100%', maxHeight: '100%', padding: "10px", background: "transparent" }}
                                  width={50}
                                  height={50}
                                  alt=""
                                  srcSet={searchIcon}
                                  src={searchIcon}
                                />
                              </button>
                            )}
                          </header>
                        </div>
                        <div className='searchColorClose lg:w-1/2 xl:w-1/3'>
                          <div> </div>
                        </div>
                      </div>
                      <button
                        style={{ whiteSpace: 'nowrap' }}
                        onClick={handleLogin}
                      >
                        {loading ? 'Loading...' : 'Log in'}
                      </button>
                    </div>
                  </div>
                </div>


              ) : userMenuMarkup}
            </div>
          </div>
        </div>
      </div>
    </>

  );

}


